import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '../../services/commonservice';
import { CommonModule } from '@angular/common';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { BaseHttpReqRespService } from '../../../../modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-page-create-input-type',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule],
  templateUrl: './page-create-input-type.component.html',
  styleUrl: './page-create-input-type.component.scss',
  providers: [CommonService],
})
export class PageCreateInputTypeComponent extends BaseHttpReqRespService implements OnInit {
  questioninputTypeForm!: FormGroup;
  public folderName!: string;
  myAppUrl: any;
  questionlist: any;
  QuestionId: any;
  successOrFailureMessage: string = '';
  public questionId!: number;
  public folderId!: number;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;
  @ViewChild('CreateCategoryModal') categoryModal!: TemplateRef<any>;
  http!: HttpClient;

  quesCategoryForm!: FormGroup;
  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;

  public width!: number;
  public maxCharacterLength!: number;

  constructor(
    @Inject('BASE_URL') baseUrl: string,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    @Inject('CONFIG_SETTINGS') configSettings: any,
    http: HttpClient,
    private _router: Router,
    _http: HttpClient,
    private formBuilder: FormBuilder,
    private commonService: CommonService, private route: ActivatedRoute,
    private renderer: Renderer2,
    private EncrDecr: EncrDecrService,
    private modalService: NgbModal
  ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl = this.baseUrl;
    this.http = _http
  }

  BackUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      let fId = this.folderId;
      let fName = this.folderName;
      if (fId > 0)
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: fId, question: fName } });
      else
        this._router.navigate(['question']);
    }
    else {
      this._router.navigate(['/programoverview']);
    }
  }

  BackToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }


  ngOnInit() {
    //this.bodyText = 'This text can be updated in modal 1';
    this.questioninputTypeForm = this.formBuilder.group({
      questioninputType: ['', [Validators.required]],
      questionCategoryId: new FormControl(''),
      width: new FormControl(''),
      shortName: new FormControl(''),
      maxCharacterLength: new FormControl('')
    });
    this.questionId = + this.route.snapshot.queryParams["questionId"];
    this.folderId = + this.route.snapshot.queryParams["folderId"];
    this.folderName = this.route.snapshot.queryParams["folderName"];
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];


    this.getDescriptionQuestionDeatils(this.questionId, this.folderId);
    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestionCategoryList();
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    //const tmpQuesCategoryName = localStorage.getItem('quesCategoryName') ? this.EncrDecr.get(localStorage.getItem('quesCategoryName')!) : null;
    const tmpQuesCategoryName = this.quesCategoryForm.get('quesCategoryName')?.value;
;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };
    this.commonService.httpPost(resourceIdList, this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }

  getDescriptionQuestionDeatils(questionId: any, folderId: any) {

    let param = "?questionId=" + questionId + "&folderId=" + folderId;

    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.DETAILS + param).subscribe(
      response => {

        this.questioninputTypeForm.patchValue({
          questioninputType: response.question,
          questionCategoryId: response.questionCategoryId,
          width: response.width,
          shortName: response.shortName,
          maxCharacterLength: response.maxCharacterLength

        });

      }, error => {

        console.log(error);
      }
    );
  }

  public saveQuestionInputType() {

    let questionId = +this.route.snapshot.queryParams["questionId"];
    let folderId = +this.route.snapshot.queryParams["folderId"];
    const userId = localStorage.getItem('userId') ? this.EncrDecr.get(localStorage.getItem('userId')!) : null;

    const payload = {
      question: this.questioninputTypeForm.value.questioninputType,
      questionCategoryId: this.questioninputTypeForm.controls.questionCategoryId.value,
      width: this.questioninputTypeForm.controls.width.value,
      shortName: this.questioninputTypeForm.controls.shortName.value,
      maxCharacterLength: this.questioninputTypeForm.controls.maxCharacterLength.value,
      createdBy: userId,
      questionId: questionId,
      folderId: folderId
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE_INPUT_TYPE,
      payload,
      httpOptions
    ).subscribe(
      questionId => {
        this.successOrFailureMessage = "Text Type Question  Saved Successfully";
        setTimeout(() => {
          this.successOrFailureMessage = '';
          this.folderId = + this.route.snapshot.queryParams["folderId"];
          this.folderName = this.route.snapshot.queryParams["folderName"];
          var location = window.location.pathname;
          if (location.includes("/client") == false) {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }
          else {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              //this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
              this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }

          }
        }, 2000);

      }, error => console.error(error));
  }

  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + '/' + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
        this.successOrFailureMessage = '';
      }, 1200);
    }, error => console.error(error));

  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
}



interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}
